<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import constants from "../../../constants/systems_constants";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Settings",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Current Settings",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Settings",
          active: true,
        },
      ],

      data: {
        term: "1",
        year: "",
        autoBreakdown: true,
      },
      getYears: [
        { name: new Date().getFullYear() },
        { name: new Date().getFullYear() - 1 },
        { name: new Date().getFullYear() - 2 },
      ],
      termError: "",
      yearError: "",
      constants: constants,
    };
  },
  watch: {
    CurrentSettings(newValue) {
      if (newValue) {
        this.data.year = this.CurrentSettings ? this.CurrentSettings.year : "";
        this.data.term = this.CurrentSettings ? this.CurrentSettings.term : "";
      }
    },
  },
  computed: {
    ...mapGetters("settings", [
      "CurrentSettings",
      "getSystemSettings",
      "SaveStatus",
    ]),
  },
  methods: {
    ...mapActions({
      FetchSettings: "settings/fetchCurrentSettings",
      Submit: "settings/changeCurrent",
      FetchSystemSettings: "settings/fetchSystemSettings",
      SubmitSetting: "settings/submitSetting",
    }),

    resetError() {
      this.termError = "";
      this.yearError = "";
    },

    submit() {
      if (this.data.term == "") {
        this.termError = "Please select the current term";
        return;
      } else {
        this.termError = "";
      }
      if (this.data.year == "") {
        this.yearError = "Please select the current study year";
        return;
      } else {
        this.yearError = "";
      }
      this.Submit(this.data);
    },
    actionSetting($event, settings) {
      this.SubmitSetting({
        key: settings.setting_key,
        value: $event.target.checked ? 1 : 0,
        id: settings.id,
      });
    },
  },
  created() {
    this.FetchSettings();
    this.FetchSystemSettings();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-10">
                <strong>Current Settings</strong>
                <p>
                  These are the settings that determin all data added in the
                  system.
                </p>
              </div>
              <div class="form-group col-md-4 mb-3">
                <div class="form-group">
                  <label for="">Current Study Year</label>
                  <select
                    class="form-control"
                    v-model="data.year"
                    name=""
                    id=""
                  >
                    <option value="" selected disabled>
                      Select Year
                    </option>
                    <option
                      v-for="(schyear, index) in getYears"
                      :value="schyear.name"
                      :key="index"
                    >
                      {{ schyear.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-4 mt-4">
                <button class="btn btn-success" @click="submit()">
                  <i class="fa fa-check"></i> Save Changes
                </button>
              </div>
            </div>
            <div v-if="getSystemSettings.length != 0">
              <div
                class="row"
                v-for="(settings, index) in getSystemSettings"
                :key="index"
              >
                <hr />
                <div class="col-md-10">
                  <strong>{{
                    constants[settings.setting_key + "_TITLE"]
                  }}</strong>
                  <p>{{ constants[settings.setting_key + "_DETAILS"] }}</p>
                </div>
                <div class="form-group col-md-4">
                  <strong class="text-muted">
                    Setting is
                    <span v-if="parseInt(settings.value) == 1" class="text-success">ON</span>
                    <span v-else class="text-danger">OFF</span>
                  </strong>
                  <div class="form-check form-switch">
                    <input
                      id="SwitchCheckSizelg"
                      class="form-switch-lg me-2 form-check-input"
                      type="checkbox"
                      :checked="parseInt(settings.value)"
                      @change="actionSetting($event, settings)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-else>
              <hr />
              <div class="col-md-10">
                <strong>Caution !!</strong>
                <p>No Other Configuration Settings Found</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
